export { datepickerVariables as datepickerCalendarVariables } from './datepickerVariables';
